import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "empty-placeholder"
}
const _hoisted_2 = { class: "create-counters" }
const _hoisted_3 = { class: "create-counters-month" }
const _hoisted_4 = { class: "create-counters-row" }
const _hoisted_5 = { class: "create-form-field" }
const _hoisted_6 = {
  class: "create-form-label",
  "data-qa": "beru-create-label-reason"
}
const _hoisted_7 = ["data-qa"]
const _hoisted_8 = {
  class: "create-form-field",
  "data-qa": "beru-create-field-date-block"
}
const _hoisted_9 = {
  class: "create-form-label",
  "data-qa": "beru-create-label-date"
}
const _hoisted_10 = ["data-qa"]
const _hoisted_11 = { class: "create-form-field" }
const _hoisted_12 = {
  class: "create-form-label",
  "data-qa": "beru-create-label-reason-type"
}
const _hoisted_13 = ["data-qa"]
const _hoisted_14 = { class: "create-form-field create-form-field--time" }
const _hoisted_15 = { class: "time-field" }
const _hoisted_16 = {
  class: "create-form-label",
  "data-qa": "beru-create-label-time-from"
}
const _hoisted_17 = ["data-qa"]
const _hoisted_18 = { class: "time-field" }
const _hoisted_19 = {
  class: "create-form-label",
  "data-qa": "beru-create-label-time-to"
}
const _hoisted_20 = ["data-qa"]
const _hoisted_21 = { class: "create-form-actions" }

import VitaCounter from "@/components/VitaCounter.vue";
import VitaEmptyPlaceholder from "./UI/VitaEmptyPlaceholder.vue";
import {
  CounterPanel,
  ErrorResponseData,
  FrvQuery,
  TimeShiftQuery,
} from "@/types";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import {
  addDays,
  addHours,
  addMonths,
  endOfMonth,
  format,
  isLastDayOfMonth,
  parse,
  isSameMonth,
  startOfDay,
  startOfMonth,
} from "date-fns";
import VitaInput from "./UI/VitaInput.vue";
import VitaButton from "./UI/VitaButton.vue";
import VitaInfoModal from "./UI/VitaInfoModal.vue";
import VitaIcon from "./UI/VitaIcon.vue";
import VitaSelect from "./UI/VitaSelect.vue";
import VitaLoaderSpinner from "./UI/VitaLoaderSpinner.vue";
import { ru } from "date-fns/locale";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { POSITION, useToast } from "vue-toastification";
import { CloseReason, CloseTypeReason, ShiftNeedsPayload } from "@/types/beru";
import { dinerCalculation, frvCore } from "@/utils/frv";
import { v4 as uuid } from "uuid";
import { AxiosError } from "axios";
import { reachGoal } from "@/utils/metrika";


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaBeruCreateModal',
  props: {
    open: { type: Boolean }
  },
  emits: ["toggleInfoModal", "created"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const store = useStore();
const toast = useToast();

const selectedDate = ref<Date>(addDays(startOfDay(new Date()), 1));
const timeFrom = ref("");
const timeTo = ref("");
const selectedReason = ref("");
const selectedTypeReason = ref("");
const isCreateModalLoading = ref(false);
const hasLoadingError = ref(false);
const timeFRVDiff = ref<FrvQuery>({ frv: 0, frvRV: 0 });
const hasSubmitError = ref(false);
const submitInProgress = ref(false);
const loadedFrvMonthKey = ref<string | null>(null);

const timeShiftQuery: TimeShiftQuery = {
  timeShift: 0,
  zupGuid: "",
  timeShiftNoDiner: 0,
  timeShiftFull: 0,
  holiday: false,
  frvRv: 0,
  dinners: {
    first: {
      startTime: 0,
      endTime: 0,
      duration: 0,
      durationMinutes: 0,
    },
    second: {
      startTime: 0,
      endTime: 0,
      duration: 0,
      durationMinutes: 0,
    },
  },
};

const shifts = ref({
  dateFrom: "",
});

const needsObj = ref<ShiftNeedsPayload>({
  pharmId: "",
  dateFrom: "",
  dateTo: "",
  reasonId: "",
  reasonName: "",
  typeReasonId: "",
  typeReasonName: "",
  tempId: "",
});

// Панели счётчиков модалки — отдельные от главного экрана, могут содержать ФРВ следующего месяца
const coreStaff = computed<CounterPanel>(() => {
  return store.getters["data/beruCoreStaff"];
});

const holidaysFRVData = computed<CounterPanel>(() => {
  return store.getters["data/beruFRV_RV"];
});

const holidaysCount = computed<number>(() => {
  return (
    store.getters["data/beruHolidays"] &&
    store.getters["data/beruHolidays"].length
  );
});

const hasHolidaysFRVData = computed(
  () => holidaysCount.value > 0 && holidaysFRVData.value,
);

const minDate = computed(() => addDays(startOfDay(new Date()), 1));

const maxDate = computed(() => endOfMonth(addMonths(minDate.value, 1)));

// Обработка события выбора даты с datepicker
const handleDateChange = async (date: Date) => {
  selectedDate.value = date;

  hasLoadingError.value = false;
  isCreateModalLoading.value = true;
  try {
    await syncFrvForSelectedDate();
  } catch {
    hasLoadingError.value = true;
  } finally {
    isCreateModalLoading.value = false;
  }

  inputEvent();
};

const pharmId = computed(() => {
  return store.getters["data/pharmId"];
});

// Праздничный ли выбранный день
const isHoliday = computed<boolean>(() => {
  return (
    store.getters["data/beruHolidays"] &&
    store.getters["data/beruHolidays"].includes(
      format(selectedDate.value, "d.M.yyyy"),
    )
  );
});

// Часовой пояс аптеки для расчёта смен в последнем дне месяца
const pharmTz = computed<number>(() => {
  return store.getters["data/pharmTz"] || 0;
});

// Пересчёт ФРВ и ФРВ РВ в счётчиках по введённому времени потребности
const inputEvent = () => {
  if (!timeFrom.value || !timeTo.value) {
    timeFRVDiff.value = { frv: 0, frvRV: 0 };
    store.commit("data/changeBeruFRV", timeFRVDiff.value);
    return;
  }

  const isLastDay = isLastDayOfMonth(selectedDate.value);
  shifts.value.dateFrom = `${format(selectedDate.value, "yyyy-MM-dd")}T${
    timeFrom.value
  }`;

  dinerCalculation(
    timeShiftQuery,
    timeFrom,
    timeTo,
    selectedDate.value,
    pharmTz.value,
  );
  timeFRVDiff.value = {
    ...frvCore(timeShiftQuery, isLastDay, isHoliday, shifts, timeFrom, timeTo),
  };

  timeShiftQuery.timeShift = timeFRVDiff.value.frv;
  timeShiftQuery.frvRv = timeFRVDiff.value.frvRV;

  store.commit("data/changeBeruFRV", timeFRVDiff.value);
};

const closeReasons = computed<CloseReason[] | []>(() => {
  return store.getters["beru/closeReasons"];
});

const closeTypeReasons = computed<CloseTypeReason[] | []>(() => {
  return store.getters["beru/closeTypeReasons"];
});

// Предзаполнение времени открытия/закрытия временем работы аптеки на завтра (OMR-7152)
const fillTomorrowWorkTime = () => {
  const workTime: string | null = store.getters["data/tomorrowWorkTime"];
  if (!workTime || workTime === "00:00-00:00") return;

  const [from, to] = workTime.split("-");
  const isValidTime = (time?: string) => !!time && /^\d{2}:\d{2}$/.test(time);
  if (!isValidTime(from) || !isValidTime(to)) return;

  timeFrom.value = from;
  timeTo.value = to;
  inputEvent();
};

const onCreateModalOpen = async () => {
  loadedFrvMonthKey.value = null; // сброс при каждом открытии модалки

  const getReasons = async () => {
    try {
      const reasonId = await store.dispatch("beru/getCloseReasons");
      if (reasonId) {
        await store.dispatch("beru/getCloseTypeReasons", reasonId);
      } else {
        store.commit("beru/setCloseTypeReasons", []);
      }
    } catch (e) {
      store.commit("beru/setCloseReasons", []);
      store.commit("beru/setCloseTypeReasons", []);
      throw e;
    }
  };

  hasLoadingError.value = false;
  isCreateModalLoading.value = true;
  try {
    await Promise.all([getReasons(), syncFrvForSelectedDate()]);
    fillTomorrowWorkTime();
  } catch {
    hasLoadingError.value = true;
  } finally {
    isCreateModalLoading.value = false;
  }
};

const resetCreateForm = () => {
  selectedReason.value = "";
  selectedTypeReason.value = "";
  selectedDate.value = addDays(startOfDay(new Date()), 1);
  timeFrom.value = "";
  timeTo.value = "";
  timeFRVDiff.value = { frv: 0, frvRV: 0 };
  loadedFrvMonthKey.value = null;
  store.commit("data/changeBeruFRV", timeFRVDiff.value);
  store.commit("data/setBeruHolidays", null);
};

// Проверка, что все переданные поля формы заполнены
const isFormFilled = (...fields: unknown[]) => {
  return fields.every(
    (field) => field !== null && field !== undefined && field !== "",
  );
};

const btnDisabled = computed(() => {
  return !isFormFilled(
    selectedReason.value,
    selectedTypeReason.value,
    selectedDate.value,
    timeFrom.value,
    timeTo.value,
  );
});

const onFormSubmit = async () => {
  const date = format(selectedDate.value, "yyyy-MM-dd");
  // Дата и время потребности в таймзоне пользователя
  const timezoneOffset = Math.abs(new Date().getTimezoneOffset() / 60);
  const toClientISO = (time: string) =>
    addHours(
      parse(`${date} ${time}`, "yyyy-MM-dd HH:mm", new Date()),
      timezoneOffset,
    ).toISOString();

  needsObj.value = {
    pharmId: pharmId.value,
    dateFrom: toClientISO(timeFrom.value),
    dateTo: toClientISO(timeTo.value),
    reasonId: selectedReason.value,
    reasonName:
      closeReasons.value.find((r) => r.id === selectedReason.value)?.reason ??
      "",
    typeReasonId: selectedTypeReason.value,
    typeReasonName:
      closeTypeReasons.value.find((r) => r.id === selectedTypeReason.value)
        ?.typeReason ?? "",
    tempId: uuid(),
  };

  try {
    hasSubmitError.value = false;
    submitInProgress.value = true;
    await store.dispatch("beru/createShiftNeeds", needsObj.value);
    toast.success("Успешно", {
      position: POSITION.BOTTOM_RIGHT,
    });
    emit("toggleInfoModal");
    emit("created");
    reachGoal('beru-create-success')
    resetCreateForm();
  } catch (err) {
    const e = err as AxiosError<ErrorResponseData>;
    hasSubmitError.value = true;

    toast.error(
      e.status === 500 ? "Ошибка загрузки данных" : e.response?.data?.message,
      {
        position: POSITION.BOTTOM_RIGHT,
      },
    );
  } finally {
    submitInProgress.value = false;
  }
};

// Месяц выбранной даты (начало месяца) - используем его как базу для всех расчётов
const selectedMonthStart = computed(() => startOfMonth(selectedDate.value));

// Совпадает ли месяц выбранный в datepicker с текущим месяцем
const isCurrentRealMonth = computed(() =>
  isSameMonth(selectedDate.value, new Date()),
);

// Месяц и год, за которые показывается ФРВ в модалке
const countersMonthTitle = computed(() => {
  const title = format(selectedMonthStart.value, "LLLL yyyy", { locale: ru });
  return title.charAt(0).toUpperCase() + title.slice(1);
});

// Загружаем ФРВ и праздники под месяц выбранной даты
const syncFrvForSelectedDate = async () => {
  const monthKey = format(selectedMonthStart.value, "yyyy-MM");

  if (loadedFrvMonthKey.value === monthKey) return;

  const mainFRV = store.getters["data/FRV"];
  const mainHolidays = store.getters["data/holidays"];
  const canReuseMainData = isCurrentRealMonth.value && mainFRV && mainHolidays;

  if (canReuseMainData) {
    // Выбранная дата в текущем месяце — переиспользуем данные главного экрана
    store.commit("data/setBeruFondWorkTime", mainFRV);
    store.commit("data/setBeruHolidays", mainHolidays);
  } else {
    // Любой другой месяц — запрашиваем данные именно за месяц выбранной даты
    const frvDate = format(selectedMonthStart.value, "yyyy-MM-dd");

    await Promise.all([
      store.dispatch("data/getBeruFondWorkTime", frvDate),
      store.dispatch("data/getBeruHolidays", frvDate),
    ]);
  }

  loadedFrvMonthKey.value = monthKey;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VitaInfoModal, {
    open: __props.open,
    onToggleInfoModal: _cache[6] || (_cache[6] = ($event: any) => (emit('toggleInfoModal'))),
    onOpen: onCreateModalOpen,
    onClose: resetCreateForm,
    "modal-icon": false,
    "modal-size": "modal-secondary modal-beru-create",
    title: "Создание потребности",
    "confirm-close-title": "Данные не сохранены",
    "confirm-close": "Вы уверены, что хотите выйти без сохранения?"
  }, {
    default: _withCtx(({ showConfirm }) => [
      _createElementVNode("div", {
        class: "modal-content",
        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
      }, [
        (isCreateModalLoading.value)
          ? (_openBlock(), _createBlock(VitaLoaderSpinner, { key: 0 }))
          : (hasLoadingError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(VitaEmptyPlaceholder, {
                  "qa-name": "beru-create-error",
                  icon: "isOffline",
                  message: "Ошибка загрузки данных",
                  description: "При загрузке данных произошла ошибка. Попробуйте обновить страницу позже.",
                  "icon-width": "100",
                  "icon-height": "100",
                  "on-refresh-click": onCreateModalOpen
                })
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(countersMonthTitle.value), 1),
                  _createElementVNode("div", _hoisted_4, [
                    (coreStaff.value)
                      ? (_openBlock(), _createBlock(VitaCounter, {
                          key: 0,
                          title: "ФРВ",
                          subtitle: "Осн.",
                          info: coreStaff.value,
                          "frv-type": "main"
                        }, null, 8, ["info"]))
                      : _createCommentVNode("", true),
                    (hasHolidaysFRVData.value)
                      ? (_openBlock(), _createBlock(VitaCounter, {
                          key: 1,
                          title: "ФРВ РВ",
                          info: holidaysFRVData.value,
                          "frv-type": "rv",
                          showIndicator: false
                        }, null, 8, ["info"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("form", {
                  class: "create-form",
                  autocomplete: "new-password",
                  onSubmit: _withModifiers(onFormSubmit, ["prevent"])
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("p", { class: "create-form-header" }, " Чтобы создать потребность, заполните все обязательные поля: ", -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, [
                      _cache[7] || (_cache[7] = _createTextVNode("Укажите причину", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["required", { 'is-filled': selectedReason.value }]),
                        "data-qa": `beru-create-label-reason-status-${selectedReason.value ? 'filled' : 'empty'}`
                      }, null, 10, _hoisted_7)
                    ]),
                    _createVNode(VitaSelect, {
                      modelValue: selectedReason.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedReason).value = $event)),
                      options: 
                closeReasons.value.map((reason) => ({
                  label: reason.reason,
                  value: reason.id,
                }))
              ,
                      name: "reason",
                      placeholderEmpty: "Нет доступных причин",
                      placeholder: "Причина",
                      "auto-select-first": "",
                      disabled: showConfirm
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, [
                      _cache[8] || (_cache[8] = _createTextVNode("Дата потребности", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["required", { 'is-filled': selectedDate.value }]),
                        "data-qa": `beru-create-label-date-status-${selectedDate.value ? 'filled' : 'empty'}`
                      }, null, 10, _hoisted_10)
                    ]),
                    _createVNode(_unref(VueDatePicker), {
                      modelValue: selectedDate.value,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((selectedDate).value = $event)),
                        handleDateChange
                      ],
                      locale: "ru",
                      "format-locale": _unref(ru),
                      format: "dd.MM.yyyy",
                      "month-name-format": "long",
                      teleport: "",
                      "enable-time-picker": false,
                      "min-date": minDate.value,
                      "max-date": maxDate.value,
                      "auto-apply": "",
                      clearable: false,
                      "prevent-min-max-navigation": "",
                      disabled: showConfirm,
                      "data-qa": "beru-create-datepicker-date-select"
                    }, {
                      "input-icon": _withCtx(() => [
                        _createVNode(VitaIcon, { name: "calendar-grey" })
                      ]),
                      "arrow-left": _withCtx(() => [
                        _createVNode(VitaIcon, { name: "chevron-left-calendar" })
                      ]),
                      "arrow-right": _withCtx(() => [
                        _createVNode(VitaIcon, {
                          style: {"transform":"rotate(-180deg)"},
                          name: "chevron-left-calendar"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "format-locale", "min-date", "max-date", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, [
                      _cache[9] || (_cache[9] = _createTextVNode("Укажите вид причины", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["required", { 'is-filled': selectedTypeReason.value }]),
                        "data-qa": `beru-create-label-reason-type-status-${selectedTypeReason.value ? 'filled' : 'empty'}`
                      }, null, 10, _hoisted_13)
                    ]),
                    _createVNode(VitaSelect, {
                      modelValue: selectedTypeReason.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTypeReason).value = $event)),
                      options: 
                closeTypeReasons.value.map((reason) => ({
                  label: reason.typeReason,
                  value: reason.id,
                }))
              ,
                      name: "reasonType",
                      placeholderEmpty: "Нет доступных видов причин",
                      placeholder: "Вид причины",
                      disabled: showConfirm
                    }, null, 8, ["modelValue", "options", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, [
                        _cache[10] || (_cache[10] = _createTextVNode("Время открытия", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["required", { 'is-filled': timeFrom.value }]),
                          "data-qa": `beru-create-label-time-from-status-${timeFrom.value ? 'filled' : 'empty'}`
                        }, null, 10, _hoisted_17)
                      ]),
                      _createVNode(VitaInput, {
                        class: "no-shadow",
                        delete: false,
                        modelValue: timeFrom.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((timeFrom).value = $event)),
                        type: "time",
                        icon: "enter",
                        disabled: showConfirm,
                        onInput: inputEvent,
                        "data-qa": "beru-create-input-time-from"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, [
                        _cache[11] || (_cache[11] = _createTextVNode("Время закрытия", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["required", { 'is-filled': timeTo.value }]),
                          "data-qa": `beru-create-label-time-to-status-${timeTo.value ? 'filled' : 'empty'}`
                        }, null, 10, _hoisted_20)
                      ]),
                      _createVNode(VitaInput, {
                        class: "no-shadow",
                        delete: false,
                        modelValue: timeTo.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((timeTo).value = $event)),
                        type: "time",
                        icon: "exit",
                        disabled: showConfirm,
                        onInput: inputEvent,
                        "data-qa": "beru-create-input-time-to"
                      }, null, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    (!showConfirm)
                      ? (_openBlock(), _createBlock(VitaButton, {
                          key: 0,
                          class: "rounded no-shadow",
                          color: "blue",
                          width: "inline",
                          disabled: btnDisabled.value,
                          "button-type": "submit",
                          btnLoading: submitInProgress.value,
                          "data-qa": "beru-create-button-submit"
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode(" Создать потребность ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "btnLoading"]))
                      : _createCommentVNode("", true)
                  ])
                ], 32)
              ], 64))
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})